import moment from 'moment';

export const parseDateWithoutSeparators = (inputValue, format) => {
  if (/^\d{8}$/.test(inputValue)) {
    const day = inputValue.substring(0, 2);
    const month = inputValue.substring(2, 4);
    const year = inputValue.substring(4, 8);
    const formattedString = `${day}.${month}.${year}`;
    const momentDate = moment(formattedString, format, true);

    if (momentDate.isValid()) {
      return { date: momentDate, string: formattedString };
    }
  }
  return null;
};
